/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { toUpper } from 'lodash'
import { useIntl } from 'react-intl'
import FormTextareaField, {
  FormTextareaFieldProps
} from '../../../../client/js/components/form/fields/FormTextareaField'

function GeographicAddressField (props: FormTextareaFieldProps) {
  const { name = 'geographicAddress', ...others } = props
  const intl = useIntl()
  return (
    <FormTextareaField
      autoComplete="street-address"
      label={intl.formatMessage({
        id: 'geographicAddress',
        defaultMessage: 'Adresse géographique'
      })}
      name={name}
      parser={toUpper}
      {...others}
    />
  )
}

export default GeographicAddressField
